// CalendarModal.js
import ReactDOM from "react-dom";
import CloseIcon from '@mui/icons-material/Close';
import { DateRange } from "react-date-range";

const CalendarModal = ({ datestate, handledateChange, onClose, onApply }) => {
  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="bg-white p-4 rounded-lg shadow-lg sm:w-[90%]  sm:max-w-[360px]">
        <div className="flex justify-between items-center mb-4">
          <span className="font-semibold text-lg">Calendar</span>
          <div className="flex items-center gap-2">
            <button
              className="bg-black text-white text-xs px-3 py-1 rounded-md"
              onClick={onApply}
            >
              Apply
            </button>
            <CloseIcon style={{ color: "#B4B4B4", cursor: "pointer" }} onClick={onClose} />
          </div>
        </div>
        <DateRange
          editableDateInputs
          onChange={(item) => handledateChange([item.selection])}
          moveRangeOnFirstSelection={false}
          ranges={datestate}
        />
      </div>
    </div>,
    document.body
  );
};

export default CalendarModal;
